// A military helmet as a line icon, for the Trenches tab of the header (the
// operator, 2026-11-02: "the same helmet as on the Trenches page, at its
// angle, nice, and as bold as the others"). It is the Trenches title's own
// helmet (TrenchHelmet.tsx) — the same shell seen from the side with its
// visor, its rim band, its chin strap and its leaning star — in one colour:
// the shell and the strap as outlines, the star filled, the stroke as heavy as
// Phosphor's bold at this size.

import type { CSSProperties } from 'react'

const SHELL =
  'M3.6 19.6C3.6 11.5 9.2 5.6 16.2 5.6c6.4 0 11.1 4.4 12 10.2l2.1 1.7c.9.8.3 2.3-.9 2.3C21 20.2 12 21.4 5.7 22.9c-1.1.3-2.1-.6-2.1-1.7v-1.6Z'
const BAND = 'M3.8 18.3C11 17.1 20 16.4 28.6 16.3'
const STRAP = 'M11.4 22.6c.5 3.6 3.5 5.5 8.6 5'
const STAR =
  'M14.95 7.32L16.39 9.89L19.33 9.85L17.33 12.01L18.28 14.8L15.61 13.57L13.25 15.32L13.59 12.4L11.19 10.71L14.08 10.13Z'

// The box is the drawing's ink, centred (the operator, 2026-11-03: the helmet
// hung low among the tab icons). Its ink, outlines with half the 2.4 stroke and
// round caps, is x 2.4..31.93, y 4.4..28.88 (measured with getBBox): middle
// (17.17, 16.64). The old box "1 3 30 26" had its middle at (16, 16), so the
// helmet stood 0.64 units low (and its visor's tip ran past the right edge,
// clipped). Same 30 x 26 box, centred on the ink: flex centring then puts the
// helmet on the middle of the tab's capitals, as the other tab marks.
const VIEW_BOX = '2.17 3.64 30 26'

export function HelmetIcon({
  size = 18,
  className,
  style,
}: {
  size?: number
  weight?: string
  className?: string
  style?: CSSProperties
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox={VIEW_BOX}
      fill="none"
      stroke="currentColor"
      strokeWidth="2.4"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      style={style}
      aria-hidden="true"
      focusable="false"
    >
      <path d={SHELL} />
      <path d={BAND} />
      <path d={STRAP} />
      <path d={STAR} fill="currentColor" stroke="none" />
    </svg>
  )
}
